import { logEvent } from "firebase/analytics";
import { analytics } from "../config/firebaseConfig";

export const trackEvent = (
  eventName: string,
  params?: Record<string, any>
) => {
  console.log("ana", analytics)
  if (!analytics) return;

  logEvent(analytics, eventName, params);
};
